import thunkMiddleware from 'redux-thunk';
import { combineReducers, applyMiddleware, createStore } from 'redux';
import { setEndpointHost, setEndpointPath, setHeader, setAccessToken } from 'redux-json-api';
import { composeWithDevTools } from 'redux-devtools-extension';
import { PathHelper } from '../utils/UrlUtil.js';

/* eslint-disable max-params */
var baseEndpointPath = 'api/data';
var defaultStoreSetup = function defaultStoreSetup(reducers, initialState) {
  var reducer = combineReducers(reducers);
  var composedStore = composeWithDevTools({
    trace: true
  });
  var enhancer = composedStore(applyMiddleware(thunkMiddleware));
  return createStore(reducer, initialState, enhancer);
};
var genericStoreSetup = function genericStoreSetup(reducers, initialState) {
  var store = defaultStoreSetup(reducers, initialState);
  store.dispatch(setEndpointHost('/'));
  store.dispatch(setEndpointPath(baseEndpointPath));
  try {
    var authToken = document.querySelector('meta[name=csrf-token]').attributes.content.value;
    store.dispatch(setHeader({
      'X-CSRF-Token': authToken
    }));
  } catch (e) {
    /* istanbul ignore next */
    console.debug('Could not find csrf token meta tag');
  }
  store.dispatch(setHeader({
    'Content-Type': 'application/vnd.api+json'
  }));
  return store;
};
var externalStoreSetup = function externalStoreSetup(reducers, initialState, endpointHost, endpointPath, accessToken) {
  var store = defaultStoreSetup(reducers, initialState);
  var host = PathHelper.ensureEndSlash(endpointHost);
  var path = PathHelper.ensureNoEndSlash(endpointPath);
  path = PathHelper.ensureNoStartSlash(path);
  store.dispatch(setEndpointHost(host));
  store.dispatch(setEndpointPath(path));
  store.dispatch(setAccessToken(accessToken));
  store.dispatch(setHeader({
    'Content-Type': 'application/json'
  }));
  return store;
};
export { baseEndpointPath, externalStoreSetup, genericStoreSetup };